import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-background text-foreground px-6"
      data-testid="notfound-page"
    >
      <div className="max-w-md text-center space-y-4">
        <div className="font-display text-6xl gold-text">404</div>
        <h1 className="font-display text-3xl">Page not found</h1>
        <p className="text-muted-foreground text-sm">
          The page you&rsquo;re looking for doesn&rsquo;t exist (yet — we&rsquo;re in Phase 0).
        </p>
        <Link
          to="/"
          className="inline-block px-5 py-2 rounded-full border border-primary/40 text-primary hover:bg-primary/10"
          data-testid="notfound-home-link"
        >
          Back home
        </Link>
      </div>
    </div>
  );
}
